export enum ContactStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  RESOLVED = 'resolved',
  CLOSED = 'closed'
}

export interface Contact {
  _id: string;
  name: string;
  email: string;
  phone?: string;
  subject: string;
  message: string;
  status: ContactStatus;
  assignedTo?: string;
  notes?: string;
  isRead: boolean;
  lastResponseAt?: string;
  ip: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateContactDto {
  name: string;
  email: string;
  phone?: string;
  subject: string;
  message: string;
  ip: string;
}

export interface UpdateContactDto {
  name?: string;
  email?: string;
  phone?: string;
  subject?: string;
  message?: string;
  status?: ContactStatus;
  assignedTo?: string;
  notes?: string;
  isRead?: boolean;
  lastResponseAt?: string;
}

export interface ContactStats {
  total: number;
  pending: number;
  inProgress: number;
  resolved: number;
  closed: number;
  unread: number;
} 